//SAF-17154 Contains individual routes for the IB depending on the role of the User.
import React from 'react';
import { Route } from 'react-router-dom';
import loadableModule from 'spark-views/main/loadableModule';
import { paths } from './ibAdminRoutes';

const IBRoutes = loadableModule(() => import('./index'));

const IBAdminRoute = () => (
	<React.Fragment>
		<Route path={paths.root} component={IBRoutes} /> {/*IB List View route for admin */}
	</React.Fragment>
);

export default IBAdminRoute;